export default __webpack_public_path__ + "static/media/logo_mang_1.bf13ecf5.svg";